/**
 * Print Power Words Class file.
 *
 * @package Science News
 */

/**
 * Print Power Words Component class.
 */
export default class PrintPowerWords {
  /**
   * Required constructor class.
   *
   * @param config
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Save children as instance properties.
    Object.assign(this, this.children);

    // Bind class methods.
    this.openPopup = this.openPopup.bind(this);

    this.ppwContent = this.children.sectionContainer.innerHTML;

    this.init();
  }

  /**
   * Do the things!
   */
  init() {
    this.children.ppwButton.addEventListener('click', this.openPopup);
  }

  /**
   * Callback for click event on print button.
   */
  openPopup(e) {
    e.preventDefault();

    /* eslint-disable max-len, no-restricted-globals */
    const win = window.open('', 'Title', `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=800,top="${(screen.height - 400)}",left="${(screen.width - 840)}"`);
    /* eslint-enable */

    win.document
      .body.innerHTML = this.ppwContent;

    win.print();
  }
}
